// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDfBAEZKlLWOFJl4sFkapxLtpogWJZrEEU",
  authDomain: "mdp-travelers.firebaseapp.com",
  projectId: "mdp-travelers",
  storageBucket: "mdp-travelers.firebasestorage.app",
  messagingSenderId: "539005058896",
  appId: "1:539005058896:web:b3aed11f7b837166f9f655",
  measurementId: "G-ETXC7GGXT9"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
